module.exports = __webpack_public_path__ + "img/mega-man.a6662d37.png";